var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHxsmsLogoDarkSm(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 69,
    viewBox: "0 0 71 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6 61.1H30.6C13.8 61.1 0 47.4 0 30.6C0 13.8 13.8 0 30.6 0H39.6C56.4 0 70.2 13.8 70.2 30.6C70.1 47.4 56.4 61.1 39.6 61.1Z",
    fill: "#F0F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 30.2971C49.8922 24.0209 45.1471 19 39.2157 19C39.1078 19 39 19.1255 39 19.251V30.2971V37.8285C39.1078 43.9791 43.8529 49 49.7843 49C49.8922 49 50 48.8745 50 48.749V37.8285V30.2971Z",
    fill: "#063A5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7 20.7C32.6 15.7 28.2 11.7 22.7 11.7C22.6 11.7 22.5 11.8 22.5 11.9V20.7V37C22.6 41.9 27 45.9 32.5 45.9C32.6 45.9 32.7 45.8 32.7 45.7V37V20.7Z",
    fill: "#063A5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8 58.4V67C21.8 68.1 23 68.8 24 68.2L39.7001 58.4H21.8Z",
    fill: "#F0F4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7 13.4C65.4003 13.4 68.4 10.4003 68.4 6.7C68.4 2.99969 65.4003 0 61.7 0C57.9997 0 55 2.99969 55 6.7C55 10.4003 57.9997 13.4 61.7 13.4Z",
    fill: "#FFEE55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHxsmsLogoDarkSm);
export default __webpack_public_path__ + "static/media/hxsms-logo-dark-sm.d0762fd52f2888a098bc7abf10f1acd5.svg";
export { ForwardRef as ReactComponent };